let titleFontSize = 3;
let titlePosition = "top-left";
let titleShadowColor = "purple";
let titleBorderSize = 0.5;
let titleShadowBlur = 15;
let titleFont = "Font 1";

let subtitleFontSize = 1.5;
let subtitlePosition = "below-title";
let subtitleSeparatePosition = "bottom-right";
let subtitleShadowColor = "purple";
let subtitleBorderSize = 0.5;
let subtitleShadowBlur = 10;  
let subtitleFont = "Font 1";
let subtitleMargin = 0;

const shadowColorMap = {
  purple: "rgba(128, 0, 255, 0.8)",
  blue: "rgba(0, 102, 255, 0.8)",
  orange: "rgba(255, 128, 0, 0.8)",
  pink: "rgba(255, 0, 128, 0.8)",
  green: "rgba(0, 204, 102, 0.8)",
  yellow: "rgba(255, 204, 0, 0.8)",
  red: "rgba(255, 0, 0, 0.8)",
  white: "rgba(255, 255, 255, 0.8)"
};

const fontFamilyMap = {
  "Font 1": 'Pricedown, "Arial Black", sans-serif',
  "Font 2": "Respondent, Arial, sans-serif",
  "Font 3": "SignPainter, cursive, sans-serif",
  "Font 4": "ChaletComprime, Arial, sans-serif",
  "Font 5": "ChaletLondon, Arial, sans-serif",
  "Font 6": "Legal, Arial, sans-serif",
  "Font 7": "Legal3D, Arial, sans-serif"
};

function getEl(id) {
  return document.getElementById(id);
}

function getValue(id, fallback = "") {
  return getEl(id)?.value ?? fallback;
}

function getActiveColor(selector, fallback = "purple") {
  return document.querySelector(`${selector} .color-option.active`)?.dataset.color || fallback;
}

function resetTextElement(el) {
  el.style.whiteSpace = "nowrap";
  el.style.boxSizing = "border-box";
  el.style.position = "absolute";
  el.style.top = "";
  el.style.bottom = "";
  el.style.left = "0px";
  el.style.right = "";
  el.style.transform = "";
  el.style.width = "100%";
  el.style.margin = "0";
  el.style.padding = "2%";
  el.style.width = "auto";
  el.style.display = "block";
  el.style.lineHeight = "1";
  el.style.textAlign = "left";
  el.style.pointerEvents = "none";
}

function applyTextVisualStyle(el, options) {
  el.style.fontSize = `${options.fontSize}rem`;
  el.style.fontFamily = options.fontFamily;
  el.style.color = "white";
  el.style.fontWeight = "bold";

  if (options.borderSize > 0) {
    el.style.webkitTextStroke = `${options.borderSize}px #000`;
    el.style.textStroke = `${options.borderSize}px #000`;
  } else {
    el.style.webkitTextStroke = "none";
    el.style.textStroke = "none";
  }

  if (options.shadowBlur > 0) {
    const color1 = options.shadowColor;
    const color2 = options.shadowColor.replace("0.8", "0.6");

    el.style.textShadow = `
      0 0 ${options.shadowBlur}px ${color1},
      0 0 ${options.shadowBlur * 2}px ${color2}
    `;
  } else {
    el.style.textShadow = "none";
  }
}

function setPosition(el, position) {
  resetTextElement(el);

  el.style.position = "absolute";
  el.style.width = "100%";
  el.style.boxSizing = "border-box";

  // сброс
  el.style.top = "";
  el.style.bottom = "";
  el.style.textAlign = "";

  // вертикаль
  if (position.startsWith("top")) {
    el.style.top = "0";
  }

  if (position.startsWith("bottom")) {
    el.style.bottom = "0";
  }

  // горизонталь (только через text-align)
  if (position.endsWith("left")) {
    el.style.textAlign = "left";
  }

  if (position.endsWith("center")) {
    el.style.textAlign = "center";
  }

  if (position.endsWith("right")) {
    el.style.textAlign = "right";
  }
}

function placeSubtitleUnderTitle(titleEl, subtitleEl, position) {
  const gap = subtitleMargin || 0;

  requestAnimationFrame(() => {
    if (position.startsWith("top")) {
const range = document.createRange();
range.selectNodeContents(titleEl);

const rect = range.getBoundingClientRect();

subtitleEl.style.top = `${titleEl.offsetTop + rect.height + gap}px`;      subtitleEl.style.left = titleEl.style.left;
      subtitleEl.style.right = titleEl.style.right;
      subtitleEl.style.transform = titleEl.style.transform;
      subtitleEl.style.textAlign = titleEl.style.textAlign;
    }

    if (position.startsWith("bottom")) {
      subtitleEl.style.bottom = "0px";

      titleEl.style.bottom = `${subtitleEl.offsetHeight + gap}px`;
      titleEl.style.top = "";
    }

    if (position.startsWith("center")) {
      subtitleEl.style.top = `${titleEl.offsetTop + titleEl.offsetHeight + gap}px`;
      subtitleEl.style.bottom = "";
      subtitleEl.style.left = titleEl.style.left;
      subtitleEl.style.right = titleEl.style.right;
      subtitleEl.style.transform = titleEl.style.transform.replace("translateY(-50%)", "");
      subtitleEl.style.textAlign = titleEl.style.textAlign;
    }
  });
}

function updateSubtitleSeparateOptions() {
  const titleSelect = getEl("title-position");
  const subtitleModeSelect = getEl("subtitle-position");
  const subtitleSeparateSelect = getEl("subtitle-separate-position-select");

  if (!titleSelect || !subtitleModeSelect || !subtitleSeparateSelect) return;

  const selectedTitlePos = titleSelect.value;
  const isSeparate = subtitleModeSelect.value === "separate";

  Array.from(subtitleSeparateSelect.options).forEach(option => {
    const shouldDisable = option.value === selectedTitlePos && isSeparate;

    option.disabled = shouldDisable;
    option.style.display = shouldDisable ? "none" : "";
  });

  if (subtitleSeparateSelect.value === selectedTitlePos && isSeparate) {
    const firstValid = Array.from(subtitleSeparateSelect.options).find(option => !option.disabled);

    if (firstValid) {
      subtitleSeparateSelect.value = firstValid.value;
      subtitleSeparatePosition = firstValid.value;
    }
  }
}

function updateSubtitleSettingsVisibility() {
  const subtitlePositionSelect = getEl("subtitle-position");
  const subtitleSeparatePositionDiv = getEl("subtitle-separate-position");
  const subtitleMarginContainer = getEl("subtitle-margin-container");
  const titlePositionSelect = getEl("title-position");

  if (subtitleSeparatePositionDiv && subtitlePositionSelect) {
    subtitleSeparatePositionDiv.classList.toggle("hidden", subtitlePositionSelect.value !== "separate");
  }

  if (subtitleMarginContainer && subtitlePositionSelect && titlePositionSelect) {
    const isWithTitle = subtitlePositionSelect.value === "below-title" || subtitlePositionSelect.value === "with-title";
    const isBottomTitle = titlePositionSelect.value.startsWith("bottom");

    subtitleMarginContainer.style.display = isWithTitle && !isBottomTitle ? "" : "none";
  }
}

function readControls() {
  titleFontSize = parseFloat(getValue("title-font-size", titleFontSize));
  titleFont = getValue("title-font", titleFont);
  titlePosition = getValue("title-position", titlePosition);
  titleBorderSize = parseFloat(getValue("title-border-size", titleBorderSize));
  titleShadowBlur = parseFloat(getValue("title-shadow-blur", titleShadowBlur));
  titleShadowColor = getActiveColor("#title-shadow-colors", titleShadowColor);

  subtitleFontSize = parseFloat(getValue("subtitle-font-size", subtitleFontSize));
  subtitleFont = getValue("subtitle-font", subtitleFont);
  subtitlePosition = getValue("subtitle-position", subtitlePosition);
  subtitleSeparatePosition = getValue("subtitle-separate-position-select", subtitleSeparatePosition);
  subtitleBorderSize = parseFloat(getValue("subtitle-border-size", subtitleBorderSize));
  subtitleShadowBlur = parseFloat(getValue("subtitle-shadow-blur", subtitleShadowBlur));
  subtitleShadowColor = getActiveColor("#subtitle-shadow-colors", subtitleShadowColor);
  subtitleMargin = parseFloat(getValue("subtitle-margin", subtitleMargin)) || 0;
}

function updateTitleStyles() {
  const previewCanvas = getEl("preview-canvas");
  const titleEl = getEl("map-title-preview");
  const subtitleEl = getEl("map-subtitle-preview");

  if (!previewCanvas || !titleEl || !subtitleEl) return;

  readControls();

  if (titleEl.parentElement !== previewCanvas) {
    previewCanvas.appendChild(titleEl);
  }

  if (subtitleEl.parentElement !== previewCanvas) {
    previewCanvas.appendChild(subtitleEl);
  }

  titleEl.textContent = getValue("map-title", "");
  subtitleEl.textContent = getValue("map-subtitle", "");

  titleEl.className = "title-text font-bold outline-none border-none focus:ring-0";
  subtitleEl.className = "subtitle-text font-semibold outline-none border-none focus:ring-0";

  applyTextVisualStyle(titleEl, {
    fontSize: titleFontSize,
    fontFamily: fontFamilyMap[titleFont] || fontFamilyMap["Font 1"],
    borderSize: titleBorderSize,
    shadowBlur: titleShadowBlur,
    shadowColor: shadowColorMap[titleShadowColor] || shadowColorMap.purple
  });

  applyTextVisualStyle(subtitleEl, {
    fontSize: subtitleFontSize,
    fontFamily: fontFamilyMap[subtitleFont] || fontFamilyMap["Font 1"],
    borderSize: subtitleBorderSize,
    shadowBlur: subtitleShadowBlur,
    shadowColor: shadowColorMap[subtitleShadowColor] || shadowColorMap.purple
  });

  setPosition(titleEl, titlePosition);

  if (subtitlePosition === "separate") {
    setPosition(subtitleEl, subtitleSeparatePosition);
  } else {
    setPosition(subtitleEl, titlePosition);
    placeSubtitleUnderTitle(titleEl, subtitleEl, titlePosition);
  }

  updateSubtitleSeparateOptions();
  updateSubtitleSettingsVisibility();
}

function bindInput(id, eventName = "input") {
  const el = getEl(id);
  if (!el) return;

  el.addEventListener(eventName, updateTitleStyles);
}

function bindColorOptions(selector) {
  document.querySelectorAll(`${selector} .color-option`).forEach(option => {
    option.addEventListener("click", () => {
      document.querySelectorAll(`${selector} .color-option`).forEach(item => {
        item.classList.remove("active");
      });

      option.classList.add("active");
      updateTitleStyles();
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  bindInput("map-title");
  bindInput("map-subtitle");

  bindInput("title-font-size");
  bindInput("title-font", "change");
  bindInput("title-position", "change");
  bindInput("title-border-size");
  bindInput("title-shadow-blur");

  bindInput("subtitle-font-size");
  bindInput("subtitle-font", "change");
  bindInput("subtitle-position", "change");
  bindInput("subtitle-separate-position-select", "change");
  bindInput("subtitle-border-size");
  bindInput("subtitle-shadow-blur");
  bindInput("subtitle-margin");

  bindColorOptions("#title-shadow-colors");
  bindColorOptions("#subtitle-shadow-colors");

  updateTitleStyles();

  window.addEventListener("resize", updateTitleStyles);
});